import styled from "styled-components";
import {UserMenuSectionBox} from "../../../user-menu/user-menu/boxes/user-menu-section.box";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const LogOutSectionDefaultBox = styled(UserMenuSectionBox)`
    margin: 2rem 0 0 0;
    ${({theme}) => theme.font.presets.regular};
`;

/* 777 */
const LogOutSectionCasino777Box = styled(UserMenuSectionBox)`
    padding: 1rem;
    margin-top: 2rem;
    &:before {
      display: none;
    }
`;

export const LogOutSectionBox = styledByTheme(LogOutSectionDefaultBox)
    .forCasino777(LogOutSectionCasino777Box)
    .apply();
